/** Central player-number type and limits. The game engine (drawing, scoring, events) supports
 * up to MAX_SUPPORTED_PLAYERS; local party mode is capped at MAX_PLAYERS while online mode
 * uses ONLINE_MAX_PLAYERS. */
export type PlayerNumber = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

/** Highest number of players the shared game primitives (colors, results, events) can render. */
export const MAX_SUPPORTED_PLAYERS = 8;

/** Local party mode player cap. */
export const MAX_PLAYERS = 8;

/** Online mode player cap. */
export const ONLINE_MAX_PLAYERS = 6;

export const PLAYER_NUMBERS: PlayerNumber[] = [0, 1, 2, 3, 4, 5, 6, 7];

/** The seats local party mode offers. Raising MAX_PLAYERS should widen every local screen at once,
 * so iterate this instead of inlining a tuple. */
export const LOCAL_PLAYER_NUMBERS: PlayerNumber[] = PLAYER_NUMBERS.slice(0, MAX_PLAYERS);

/** The seats an online room offers. */
export const ONLINE_PLAYER_NUMBERS: PlayerNumber[] = PLAYER_NUMBERS.slice(0, ONLINE_MAX_PLAYERS);
